import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a544ef76&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./Komcard.scss?vue&type=style&index=0&id=a544ef76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a544ef76",
  null
  
)

export default component.exports